import React from 'react';

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="23" viewBox="0 0 14 23" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M7 0l7 8.375H0zM7 22.749l7-8.374H0z" />
    </g>
  </svg>
);
